export const RETAILERS = '/retailers';
export const CATEGORIES = '/categories';
export const SUBCATEGORIES = '/subcategories';
export const PRODUCTS = '/products';
export const ORDERS = '/orders';